import { EventResponse, EventResponseStatusEnum } from "@jnext/ts-axios-eventformat";
import moment from "moment";
import { DEFAULT_FORMAT_DATE } from ".";

export const getEventStatusColor = (status: EventResponseStatusEnum | undefined, translate: (str: string, params?: Record<string, any>) => string) => {
    const statusCode = `EVENT_STATUS_COLOR_${status}`;
    const backgroundColor = translate(statusCode);

    return {
        color: "#FFF",
        backgroundColor: backgroundColor || "#888",
    };
};


export const getEventStatusHeaderText = (event: EventResponse, translate: (str: string, params?: Record<string, any>) => string) => {
    const status = `EVENT_STATUS_${event.status}`;
    switch (event.status) {
        case "OPEN":
            return translate(status, {
                date: moment(event.end).utcOffset(0).format(DEFAULT_FORMAT_DATE),
            });
        case "UPCOMING":
            return translate(status, {
                date: moment(event.begin).utcOffset(0).format(DEFAULT_FORMAT_DATE),
            });
        default:
            return translate(status);
    }
};

export const getEventCommunicationText = (event: EventResponse, translate: (str: string, params?: Record<string, any>) => string) => {
    return {
        text: getEventStatusHeaderText(event, translate),
        ...getEventStatusColor(event.status, translate),
    }
}